import { IMAGE_DATA_CLEAR, IMAGE_DATA_SET_BACK, IMAGE_DATA_SET_FRONT } from '../constants/index';

const imageDataSetFront = (imgData: any) => ({
  type: IMAGE_DATA_SET_FRONT,
  payload: { imgData },
});

const imageDataSetBack = (imgData: any) => ({
  type: IMAGE_DATA_SET_BACK,
  payload: { imgData },
});

const imageDataClear = () => ({
  type: IMAGE_DATA_CLEAR,
});

export { imageDataClear, imageDataSetBack, imageDataSetFront };
